import { action, observable } from 'mobx';
import { api } from '../config';
import { toJS } from 'mobx';

// Helpers
import { getPath } from '../helpers/helpers';

// Components
import SessionStore from './SessionStore';
import ManagerStore from './ManagerStore';
import SettingsStore from './SettingsStore';
import ProctorStore from './ProctorStore';

// Dependencies
import moment from 'moment';

let obx = observable({
  filterParams: {
    fname:'',
    lname:'',
    status:''
  },
  defaultPlatformVersion: 2,
  setPlatformVersion: action(function (version) {
    obx.defaultPlatformVersion = version;
    if (obx.exam) {
      obx.exam.platformVersion = version;
    }
  }),
  addLocation: action(function () {
    const location = {
      location: null,
      timeType: 'between',
      startTime: null,
      endTime: null,
      capacity: 0
    }
    obx.exam.configuration.instructorAsProctor.push(location);

    if (obx.configuration) {
      obx.configuration.instructorAsProctor.push(location);
    }
  }),
  removeLocation: action(function (index) {
    obx.exam.configuration.instructorAsProctor.splice(index, 1);

    if (obx.configuration) {
      obx.configuration.instructorAsProctor.splice(index, 1);
    }
  }),
  updateLocation: action(function (index, location) {
    obx.exam.configuration.instructorAsProctor[index] = location;

    if (obx.configuration) {
      obx.configuration.instructorAsProctor[index] = location;
    }
  }),
  exam: {
    title: '',
    type: "Online",
    description: '',
    useProctorManager: false,
    requireApproval: false,
    url: '',
    enableAppointmentSuggestions: false,
    platformVersion: 2,
    configuration: {
      examOpenDate: '',
      examCloseDate: '',
      scheduleOpenDate: '',
      scheduleCloseDate: '',
      password: '',
      duration: 0,
      attempts: 1,
      requiredSoftware: '',
      studentNotes: '',
      proctorNotes: '',
      proctorTypes: []
    }
  },
  defaultExam: null,
  configuration: null,
  examEnrollments: [],
  // Reset exam data
  resetExam: action(function (examType) {
    obx.configuration = null;

    obx.exam = {
      title: '',
      type: examType === 'Written' ? 'Written' : 'Online',
      description: '',
      useProctorManager: false,
      requireApproval: false,
      url: '',
      enableAppointmentSuggestions: false,
      isLimitedScope: false,
      platformVersion: 2,
      configuration: {
        examOpenDate: '',
        examCloseDate: '',
        scheduleOpenDate: '',
        scheduleCloseDate: '',
        password: '',
        duration: 0,
        attempts: 1,
        requiredSoftware: '',
        studentNotes: '',
        proctorNotes: '',
        proctorTypes: [],
        permittedBathroomBreak: false,
        permittedBathroomBreakInformation: '',
        permittedBlankPaper: false,
        permittedBlankPaperInformation: '',
        permittedCalculator: false,
        permittedCalculatorInformation: '',
        permittedDictionary: false,
        permittedDictionaryInformation: '',
        permittedEarplugs: false,
        permittedEarplugsInformation: '',
        permittedFormulaSheet: false,
        permittedFormulaSheetInformation: '',
        permittedNotes: false,
        permittedNotesInformation: '',
        permittedOtherItems: '',
        permittedTextbook: false,
        permittedTextbookInformation: '',
        permittedWebsites: false,
        permittedWebsitesInformation: '',
        instructorAsProctor: []
      }
    }
  }),
  resetExamSession: action(function() {
    obx.examSession = {
      status: '',
      sessionType: '',
      appointmentDate: '',
      dateScheduled: '',
      dateApproved: '',
      proctor: {
        firstName: '',
        lastName: '',
        phone: ''
      },
      location: {
        accountName: '',
        address1: '',
        address2: '',
        region: '',
        country: '',
        postalCode: '',
        place: '',
        latitude: '',
        longitude: ''
      }
    }
  }),
  // Get a specific exam
  getExam: action(function(sid, courseSid) {
    SessionStore.startLoading('Loading…', 'Exam');
    obx.resetExam();

    let course = courseSid;

    if(!course) {
      course = SessionStore.userData.courseSid;
    }

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${course}/exams/${sid}`)
      .then(response => {
        obx.exam = response.data;
        obx.defaultExam = response.data;
        SessionStore.finishLoading('Exam');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get written exam file
  getExamFile: action(function(configurationSid, fileName, installSid, backgroundLoad) {
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'getExamFile');
    }

    let install = SessionStore.userData.installSid;

    if(installSid) {
      install = installSid;
    }

    api.get(`/installs/${install}/examConfigurations/${configurationSid}/examFile`, {
      responseType: 'arraybuffer'
    })
      .then(response => {
        const tempLink = document.createElement('a');
        const file = new Blob([response.data], {type: 'application/pdf'});

        if(window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, fileName);
        } else {
          const fileUrl = URL.createObjectURL(file);

          tempLink.href = fileUrl;
          tempLink.download = fileName;
          tempLink.click();

          window.URL.revokeObjectURL(fileUrl);
        }

        if(!backgroundLoad) {
          SessionStore.finishLoading('getExamFile');
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get exam enrollments
  getEnrollments: action(function (sid, filters, noLoad) {

    if(!noLoad){
      SessionStore.startLoading('Loading…', 'ExamEnrollments');
    }

    let query = '?limit=50';

    if(filters) {
      for(var key in filters) {
        if(filters[key]) {
          query += `&${key}=${filters[key]}`
        }
      }
    }

    api.get(`/install/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${sid}/enrollments${query}`)
      .then(response => {
        obx.examEnrollments = response.data.enrollments.results;
        if (response.data.enrollments.next) {

          let nextUrl = getPath(response.data.enrollments.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.overviewNext = nextUrl;
        } else {
          obx.overviewNext = "";
        }

        // Loop through enrollments and check for
        // root school and then get data if needed
        obx.examEnrollments.forEach(enrollment => {
          if(
            enrollment.rootAffiliation &&
            enrollment.rootAffiliation.install.sid !== SessionStore.userData.installSid
          ) {
            // Get a list of all proctor types
            if(
              ProctorStore.proctorTypeCategories.length === 0 &&
              SessionStore.loadingCalls.indexOf('GetProctorTypes') < 0
            ) {
              ProctorStore.getProctorTypes();
            }

            const callback = (data) => {
              enrollment.proctorGroups = data;

              enrollment.proctorGroups.forEach(proctorGroup => {
                const typeArr = [];

                proctorGroup.proctorTypes.forEach(type => {
                  const typeObj = toJS(ProctorStore.proctorTypeCategories).filter(cat => {
                    return cat.sid === type;
                  });

                  if(typeArr.indexOf(typeObj[0].title) < 0) {
                    typeArr.push(typeObj[0].title);
                  }
                });

                proctorGroup.proctorTypes = typeArr;
              });
            }

            // Wait until all proctor types are stored
            // then get proctor groups for this session
            const catDelay = setInterval(function(){
              if(ProctorStore.proctorTypeCategories.length > 0) {
                clearInterval(catDelay);
                ProctorStore.getSessionProctorGroups(sid, enrollment.session.sid, null, callback);
              }
            }, 100);
          }
        })
        SessionStore.finishLoading('ExamEnrollments');
      })
      .catch(error => {
        SessionStore.finishLoading('ExamEnrollments');
        SessionStore.throwError(error);
      });
  }),
  updateExamAssignment: action(async function(added, removed, examSid, callback=null){

    const payload = {added, removed}
    try{
      await api.put(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/assignment`, payload)
    } catch (e) {
      SessionStore.throwError(e);
    }

    if(callback) {
      callback();
    }
  }),

  // Create exam
  createExam: action(function(func, component){
    SessionStore.startLoading('Loading…', 'CreateExam');

    let data = { ...obx.exam }

    // If we’ve imported an exam, use that data to fill in any gaps
    if(obx.importedLmsExam) {
      if(!data.title) {
        data.title = obx.importedLmsExam.title;
      }

      if(obx.importedLmsExam.attemptsAllowed) {
        data.configuration.attempts = obx.importedLmsExam.attemptsAllowed;
      }

      if(!data.description) {
        data.description = obx.importedLmsExam.description;
      }

      if(!data.configuration.duration) {
        data.configuration.duration = obx.importedLmsExam.duration;
      }

      if(!data.configuration.examOpenDate) {
        data.configuration.examOpenDate = moment(obx.importedLmsExam.examOpenDate);
      }

      if(!data.configuration.examCloseDate) {
        data.configuration.examCloseDate = moment(obx.importedLmsExam.examCloseDate);
      }

      if(!data.url) {
        data.url = obx.importedLmsExam.examUrl;
      }

      if(!data.configuration.password) {
        data.configuration.password = obx.importedLmsExam.password;
      }

      if(obx.importedLmsExam && obx.importedLmsExam.examId) {
        data.configuration.apiExamId = obx.importedLmsExam.examId.toString();
      }
    }

    delete data.pendingApprovals;
    delete data.openSessionEvents;

    data.configuration.instructorAsProctor.forEach(function (el) {
      delete el.sid;
    });

    if(!data.configuration.scheduleOpenDate) {
      data.configuration.scheduleOpenDate = moment('1-1-2000 00:00', 'M-D-YYYY HH:mm Z').toISOString()
    }

    if(!data.configuration.scheduleCloseDate) {
      data.configuration.scheduleCloseDate = moment('1-1-2070 00:00', 'M-D-YYYY HH:mm Z').toISOString()
    }

    // If proctor approval is required on an
    // institution level, set it to true
    if(SettingsStore.settings && SettingsStore.settings.requireManagerProctorApproval) {
      data.requireApproval = true;
    }

    api.post(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams`, data)
      .then(response => {
        component.setState({
          examSid: response.data.sid
        }, function(){
          func(response.data.sid, response.data.configuration.sid);
        });
        obx.examSid = response.data.sid;

        SessionStore.finishLoading('CreateExam');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  /**
   * updateExamData - Updates obx.exam so that it can be used in all components
   * through the ExamStore
   * @param {object} data - New information to be saved
   * @param {boolean} isConfiguration - Determines if data should go inside of configuration object
   * @param {string} categorySid - Unique identifier(TS) used for modality options
   */
  updateExamData: action(function (data, isConfiguration, categorySid) {
    let newData = null;

    if (isConfiguration) {
      for (let key in data.configuration) {
        if (key) {
          if (key === 'modalityOptions') {
            // We don't need to check for categorySid here because
            // modality options are now always tied to a specific categorySid.
            // If we have new modality options we have a categorySid as well
            if (!obx.exam.configuration[key]) {
              obx.exam.configuration[key] = {};
            }
            obx.exam.configuration[key][categorySid] =
              data.configuration[key][categorySid];
          } else {
            newData = data.configuration[key];
            obx.exam.configuration[key] = newData;
          }

          // Deletes modality options for a proctor types that aren't in the proctor type array
          if(key === 'proctorTypes') {
            for(let subcategorySid in obx.exam.configuration.modalityOptions) {
              if (!data.configuration.proctorTypes.includes(subcategorySid)) {
                delete obx.exam.configuration.modalityOptions[subcategorySid]

                // Deletes the modality option object when it will be empty
                if(Object.keys(obx.exam.configuration.modalityOptions).length === 0) {
                  delete obx.exam.configuration.modalityOptions;
                }
              }
            }
          }
        }
      }
    } else {
      for (let key in data) {
        if (key) {
          newData = data[key];
          obx.exam[key] = newData;
        }
      }
    }
  }),
  // Update exam API call
  updateExam: action(function (sid, func, skipLoad, courseSid) {
    if(!skipLoad) {
      SessionStore.startLoading('Loading…', 'UpdateExam');
    }

    let course = courseSid;

    if(!course) {
      course = SessionStore.userData.courseSid;
    }

    let data = { ...obx.exam }

    // Remove unnecessary properties
    delete data.sid;
    delete data.applicationInstallSid;
    delete data.courseSid;
    delete data.createdDate;
    delete data.editDate;
    delete data.configuration.sid;
    delete data.configuration.examSid;
    delete data.configuration.exam;
    delete data.configuration.enrollmentSid;
    delete data.configuration.createdDate;
    delete data.configuration.editDate;
    delete data.configuration.approved;
    delete data.configuration.approvedBy;
    delete data.summary;
    delete data.pendingApprovals;
    delete data.openSessionEvents;
    delete data.configuration.attachments;
    delete data.configuration.locked;
    delete data.configuration.attemptsRemaining;
    delete data.configuration.examConfigurationSid;
    delete data.configuration.referenceExamConfigurationSid;
    delete data.course;
    delete data.configuration.type;
    delete data.bVirtualTitle;

    if(data.contactUserSid === null) {
      delete data.contactUserSid;
    }

    if(data.configuration.instructorAsProctor) {
      data.configuration.instructorAsProctor.forEach(function (el) {
        delete el.createdDate;
        delete el.editDate;

        if (el.sid === null) {
          delete el.sid;
        }
      });
    } else {
      data.configuration.instructorAsProctor = [];
    }

    // If proctor approval is required on an
    // institution level, set it to true
    if(SettingsStore.settings && SettingsStore.settings.requireManagerProctorApproval) {
      data.requireApproval = true;
    }

    if(data.configuration.password === null) {
      delete data.configuration.password;
    }

    if(data.configuration.url === null) {
      delete data.configuration.url;
    }

    if(data.type && data.type.toLowerCase() === 'written' && data.configuration.password) {
      delete data.configuration.password;
    }

    api.put(`/installs/${SessionStore.userData.installSid}/courses/${course}/exams/${sid}`, data)
      .then(response => {
        if(!skipLoad) {
          SessionStore.finishLoading('UpdateExam');
        }

        if(func) {
          func(response.data.sid, response.data.configuration.sid);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Delete exam
  deleteExam: action(function(examSid, courseSid, callback) {
    SessionStore.startLoading('Loading…', 'deleteExam');

    api.delete(`/installs/${SessionStore.userData.installSid}/courses/${courseSid}/exams/${examSid}`)
    .then(response => {
      SessionStore.finishLoading('UpdateExam');

      if(callback) {
        callback();
      }
    })
    .catch(error => {
      SessionStore.throwError(error);
    });
  }),
  // Set initial configuration data
  setConfigurationData: action(function () {
    obx.configuration = null;
    obx.configuration = { ...obx.defaultExam.configuration };

    if(obx.defaultExam.configuration.instructorAsProctor) {
      obx.configuration.instructorAsProctor = [...obx.defaultExam.configuration.instructorAsProctor];
    } else {
      obx.configuration.instructorAsProctor = [];
    }

    // Remove unnecessary properties
    delete obx.configuration.sid;
    delete obx.configuration.exam;
    delete obx.configuration.enrollmentSid;
    delete obx.configuration.createdDate;
    delete obx.configuration.editDate;
    delete obx.configuration.approved;
    delete obx.configuration.approvedBy;
  }),
  // Reset custom configuration data
  resetConfigurationData: action(function () {
    obx.customConfiguration = null;
    obx.configuration = {};
  }),
  // Get custom configuration data
  getConfigurationData: action(function (examSid, sid, courseSid, callback) {
    SessionStore.startLoading('Loading…', 'GetConfiguration');
    obx.resetConfigurationData();

    let course = courseSid;

    if(!course) {
      course = SessionStore.userData.courseSid;
    }

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${course}/exams/${examSid}/configurations/${sid}`)
      .then(response => {
        obx.configuration = response.data;
        SessionStore.finishLoading('GetConfiguration');

        if(callback) {
          callback(response.data);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  /**
   * updateConfigurationData - Updates obx.configuration so that it can be used in
   * all components through the ExamStore
   * @param {object} data - new information to save
   * @param {string} categorySid - Unique identifier(TS) used for modality options
   */
  updateConfigurationData: action(function (data, categorySid) {
    let newData = null;

    for (let key in data) {
      if (key) {
        if (key === 'modalityOptions') {
          if (!obx.configuration[key]) {
            obx.configuration[key] = {};
          }
          obx.configuration[key][categorySid] = data[key][categorySid];
        } else {
          newData = data[key];
          obx.configuration[key] = newData;
        }

        // Deletes modality options for a proctor types that aren't in the proctor type array
        if (key === 'proctorTypes') {
          for (let subcategorySid in obx.configuration.modalityOptions) {
            if (!data.proctorTypes.includes(subcategorySid)) {
              delete obx.configuration.modalityOptions[subcategorySid];

              // Deletes the modality option object when it will be empty
              if (Object.keys(obx.configuration.modalityOptions).length === 0) {
                delete obx.configuration.modalityOptions;
              }
            }
          }
        }
      }
    }
  }),
  // Update exam configuration api call
  updateConfiguration: action(function (examSid, sid, func, courseSid, callback) {
    SessionStore.startLoading('Loading…', 'UpdateConfiguration');

    let course = courseSid;

    if(!course) {
      course = SessionStore.userData.courseSid;
    }

    let data = { ...obx.configuration }

    let configurationSid = sid;

    // If we’re approving a change request, use that sid
    if(data.referenceExamConfigurationSid) {
      configurationSid = data.referenceExamConfigurationSid;
    }

    // Remove unnecessary properties
    delete data.sid;
    delete data.configuration;
    delete data.exam;
    delete data.examSid;
    delete data.enrollmentSid;
    delete data.createdDate;
    delete data.editDate;
    delete data.approved;
    delete data.approvedBy;
    delete data.locked;
    delete data.attemptsRemaining;
    delete data.type;

    if(data.referenceExamConfigurationSid) {
      data.refConfigSid = sid;
      delete data.referenceExamConfigurationSid;
    }

    if(data.attachments.length === 0 || !data.refConfigSid) {
      delete data.attachments;
    }

    if(!data.attachments && data.refConfigSid) {
      delete data.refConfigSid;
    }

    if(data.configuration && data.configuration.instructorAsProctor) {
      data.configuration.instructorAsProctor.forEach(function (el) {
        delete el.createdDate;
        delete el.editDate;
        delete el.sid;
      });
    }

    if(data.password === null) {
      delete data.password;
    }

    if(data.url === null) {
      delete data.url;
    }

    data.instructorAsProctor.forEach(function(el) {
      delete el.sid;
      delete el.createdDate;
      delete el.editDate;
    });

    api.put(`/installs/${SessionStore.userData.installSid}/courses/${course}/exams/${examSid}/configurations/${configurationSid}`, data)
      .then(response => {
        SessionStore.finishLoading('UpdateConfiguration');

        if(func) {
          func(response.data.examSid, response.data.sid);
        }

        if(callback) {
          obx.exam.configuration = response.data;

          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Create exam configuration
  changeRequestSid: null,
  createConfiguration: action(function (examSid, enrollmentSid, func, referenceExamConfigurationSid) {
    SessionStore.startLoading('Loading…', 'CreateConfiguration');

    let data = { ...obx.configuration }

    // Add the enrollment sid
    if(enrollmentSid) {
      data.enrollmentSid = enrollmentSid;
    }

    // Add an existing configurationSid
    if(referenceExamConfigurationSid) {
      data.referenceExamConfigurationSid = referenceExamConfigurationSid;
    } else {
      delete data.referenceExamConfigurationSid;
    }

    // Remove unnecessary properties
    delete data.examSid;
    delete data.attachments;
    delete data.locked;
    delete data.attemptsRemaining;
    delete data.type;

    data.instructorAsProctor.forEach(function (el) {
      delete el.createdDate;
      delete el.editDate;
      delete el.sid;
    });

    if(data.password === null) {
      delete data.password;
    }

    if(data.url === null) {
      delete data.url;
    }

    api.post(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${examSid}/configurations`, data)
      .then(response => {
        SessionStore.finishLoading('CreateConfiguration');

        if(referenceExamConfigurationSid) {
          obx.changeRequestSid = response.data.sid;
        }

        obx.configuration.sid = response.data.sid;

        if(func) {
          func(response.data.examSid, response.data.sid, response.data.attachments);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  deleteConfiguration: action(function (examSid, sid) {
    SessionStore.startLoading('Loading…', 'DeleteConfiguration');

    api.delete(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/exams/${examSid}/configurations/${sid}`)
      .then(response => {
        obx.getEnrollments(examSid);
        SessionStore.finishLoading('DeleteConfiguration');
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  examSession: {
    status: '',
    sessionType: '',
    appointmentDate: '',
    dateScheduled: '',
    dateApproved: '',
    proctor: {
      firstName: '',
      lastName: '',
      phone: ''
    },
    location: {
      accountName: '',
      address1: '',
      address2: '',
      region: '',
      country: '',
      postalCode: '',
      place: '',
      latitude: '',
      longitude: ''
    }
  },
  getExamSession: action(function (examSid, sessionSid, callback, scheduled) {
    SessionStore.startLoading('Loading…', 'GetExamSession');
    let { installSid } = SessionStore.userData;

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}`)
      .then(response => {
        obx.examSession = response.data;
        obx.exam.configuration = response.data.examConfiguration;

        // If we’re requiring a scheduled session, make sure the
        // status is scheduled and re-run the call if it’s not
        if(scheduled && response.data.status === 'Needs Proctor') {
          obx.getExamSession(examSid, sessionSid, callback, scheduled);
        } else {
          SessionStore.finishLoading('GetExamSession');
        }

        if(callback) {
          callback(response);
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  setExamSessionAsNeedsReview: action(function(examSid, installSid, sessionSid, callback){
    let patch_data={reviewStatus: false}

    SessionStore.startLoading('Loading…', "setExamSessionAsNeedsReview");

    api.patch(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/reviewStatus`, patch_data)
    .then(response => {
      SessionStore.showToaster("Session marked as Unreviewed!", "success");
      if(callback){
        callback();
      }
      SessionStore.finishLoading('setExamSessionAsNeedsReview');
    })
    .catch(error => {
      SessionStore.throwError(error);
    })
  }),
  // Get exam session by accessCode
  getExamSessionByAccessCode: action(function(accessCode) {
    SessionStore.startLoading('Loading…', 'GetExamSessionByAccessCode');

    api.get(`/sessions/${accessCode}`)
      .then(response => {
        obx.examSession = response.data;
        SessionStore.finishLoading('GetExamSessionByAccessCode');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  examEvents: [],
  // Get incidents for an exam
  getExamEvents: action(function (examSid) {
    SessionStore.startLoading('Loading…', 'GetExamEvents');
    let { installSid } = SessionStore.userData;
    api.get(`/installs/${installSid}/exams/${examSid}/events?limit=500`)
      .then(response => {
        obx.examEvents = response.data.results;
        SessionStore.finishLoading('GetExamEvents');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get incidents for a session
  sessionEvents: [],
  getSessionEvents: action(function(installSid, examSid, sessionSid, session) {
    SessionStore.startLoading('Loading…', 'GetSessionEvents');

    obx.sessionEvents = [];

    let dataInstallSid = installSid;

    if(!dataInstallSid) {
      dataInstallSid = SessionStore.userData.installSid;
    }

    api.get(`/installs/${dataInstallSid}/exams/${examSid}/sessions/${sessionSid}/events`)
      .then(response => {
        obx.sessionEvents = response.data.results;

        // Add session data to each incident
        if(session) {
          obx.sessionEvents.forEach(incident => {
            incident.session = session;
          });
        }

        SessionStore.finishLoading('GetSessionEvents');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Reset session incidents
  resetSessionEvents: action(function(){
    obx.sessionEvents = [];
  }),
  // Get a specific incident
  incident: {},
  getSingleSessionEvent: action(function(installSid, examSid, sessionSid, incidentSid, component) {
    SessionStore.startLoading('Loading…', 'GetSpecificEvent');

    obx.incident = {};

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${incidentSid}`)
      .then(response => {
        obx.incident = response.data;

        if(component) {
          component.setState({
            incidentData: response.data
          })

          // Make sure date is the right format
          let incidentData = {...component.state.incidentData};
          incidentData.eventTime = response.data.eventTime;

          component.setState({
            incidentData
          });
          component.setState({
            date: moment(response.data.eventTime)
          });
        }

        SessionStore.finishLoading('GetSpecificEvent');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  incidentTypes: [],
  // Get incident types
  getIncidentTypes: action(function(){
    SessionStore.startLoading('Loading…', 'GetIncidentTypes');

    obx.incidentTypes = [];

    api.get(`/sessions/events/types`)
      .then(response => {
        obx.incidentTypes = response.data.results;
        SessionStore.finishLoading('GetIncidentTypes');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Close Incident
  closeExamEvent: action(function (examSid, event, callback) {
    SessionStore.startLoading('Loading…', 'CloseExamEvent');
    let { installSid } = SessionStore.userData;
    let sessionSid = event.examSessionSid;
    let eventReportSid = event.sid;
    api.put(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${eventReportSid}/close`)
      .then( () => {
        SessionStore.finishLoading('CloseExamEvent');
        event.status = 'Closed';
        callback();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create session incident
  createSessionEvent: action(function(installSid, examSid, sessionSid, data, func){
    SessionStore.startLoading('Loading…', 'CreateSessionEvent');

    delete data.eventType;

    api.post(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events`, data)
      .then( () => {
        obx.getSessionEvents(installSid, examSid, sessionSid);
        SessionStore.finishLoading('CreateSessionEvent');
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update session incident
  updateSessionEvent: action(function(installSid, examSid, sessionSid, eventSid, data, func){
    SessionStore.startLoading('Loading…', 'UpdateSessionEvent');

    delete data.sid;
    delete data.examSessionSid;
    delete data.createdDate;
    delete data.eventType;

    api.put(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${eventSid}`, data)
      .then( () => {
        obx.getSessionEvents(installSid, examSid, sessionSid);
        ManagerStore.incidentSid = null;
        SessionStore.finishLoading('UpdateSessionEvent');
        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete session incident
  deleteSessionEvent: action(function(installSid, examSid, sessionSid, eventSid){
    SessionStore.startLoading('Loading…', 'DeleteSessionEvent');

    api.delete(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/events/${eventSid}`)
      .then( () => {
        SessionStore.finishLoading('DeleteSessionEvent');
        obx.getSessionEvents(installSid, examSid, sessionSid);
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update attachments
  examAttachments: null,
  examFiles: null,
  updateExamAttachments: action(function(examSid, configurationSid, data, func){
    SessionStore.startLoading('Loading…', 'UpdateExamAttachments');

    const { installSid, courseSid } = SessionStore.userData;

    let formData = new FormData();

    if(data.attachments) {
      for(let i = 0; i < data.attachments.length; i++) {
        formData.append('attachments[]', data.attachments[i]);
      }
    } else if(data.examFiles) {
      for(let i = 0; i < data.examFiles.length; i++) {
        formData.append('examFiles[]', data.examFiles[i]);
      }
    }

    let configSid = configurationSid;

    if(obx.changeRequestSid) {
      configSid = obx.changeRequestSid;
    }

    api.put(`/installs/${installSid}/courses/${courseSid}/exams/${examSid}/configurations/${configSid}/attachments`, formData)
      .then( () => {
        SessionStore.finishLoading('UpdateExamAttachments');

        obx.changeRequestSid = null;

        func();
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Delete exam attachments API call
  deleteAttachments: [],
  deleteExamAttachments: action(function (examSid, examConfigSid, data, callback) {
    SessionStore.startLoading('Loading…', 'DeleteExamAttachments');

    let installSid = SessionStore.userData.installSid;
    let courseSid = SessionStore.userData.courseSid;

    api.delete(`/installs/${installSid}/courses/${courseSid}/exams/${examSid}/configurations/${examConfigSid}/attachments`, {data})
      .then(response => {
        SessionStore.finishLoading('DeleteExamAttachments');

        obx.deleteAttachments = [];

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      });
  }),
  // Get exam configurations awaiting approval
  examApprovals: [],
  examApprovalsNext: null,
  getExamApprovals: action(function(filters){
    SessionStore.startLoading('Loading…', 'GetExamApprovals');

    obx.examApprovals = [];

    let query = '?limit=50&sortKeys=examOpenDate';

    if(filters) {
      for(var key in filters) {
        if(filters[key]) {
          query += `&${key}=${filters[key]}`
        }
      }
    }

    api.get(`/installs/${SessionStore.userData.installSid}/unapprovedConfigurations${query}`)
      .then(response => {
        obx.examApprovals = response.data.results;

        // Set pagination next url
        if(response.data.next) {
          // API returns a url with a different domain for the next link
          // so create an anchor element and set its href to the next link
          // and then grab the pathname and query from that
          let nextUrl = getPath(response.data.next);
          nextUrl = nextUrl.replace('/v1', '');
          obx.examApprovalsNext = nextUrl;
        } else {
          obx.examApprovalsNext = null;
        }

        SessionStore.finishLoading('GetExamApprovals');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update exam approval
  updateExamApproval: action(function(examSid, configurationSid, data, callback, courseSid, ){
    SessionStore.startLoading('Loading…', 'UpdateExamApproval');

    api.put(`/installs/${SessionStore.userData.installSid}/courses/${courseSid}/exams/${examSid}/configurations/${configurationSid}/status`, data)
      .then(response => {
        SessionStore.finishLoading('UpdateExamApproval');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Update configuration status
  updateConfigurationStatus: action(function(examSid, configurationSid, data, callback, backgroundLoad){
    if(!backgroundLoad) {
      SessionStore.startLoading('Loading…', 'UpdateConfigurationStatus');
    } else {
      SessionStore.startBackgroundLoading('UpdateConfigurationStatus');
    }

    let query = '';

    if(examSid) {
      query = `?examSid=${examSid}`
    }

    api.put(`/installs/${SessionStore.userData.installSid}/examConfigurations/${configurationSid}/status${query}`, data)
      .then(response => {
        if(!backgroundLoad) {
          SessionStore.finishLoading('UpdateConfigurationStatus');
        } else {
          SessionStore.finishBackgroundLoading('UpdateConfigurationStatus');
        }

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Create communication proxy
  proxyNumbers: {},
  createCommProxy: action(function(examSid, sessionSid){
    SessionStore.startLoading('Loading…', 'CreateCommProxy');

    api.post(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/communicationProxy`)
      .then(response => {
        obx.proxyNumbers = response.data;
        SessionStore.finishLoading('CreateCommProxy');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get communication proxy
  getCommProxy: action(function(examSid, sessionSid){
    SessionStore.startLoading('Loading…', 'GetCommProxy');

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/communicationProxy`)
      .then(response => {
        obx.proxyNumbers = response.data;
        SessionStore.finishLoading('GetCommProxy');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),
  // Get exams from LMS (temporarily hard-coded)
  lmsExams: [],
  getLMSExams: action(function(failedCallback, passedCallback){
    SessionStore.startLoading('Loading…', 'getLMSExams');

    api.get(`/installs/${SessionStore.userData.installSid}/courses/${SessionStore.userData.courseSid}/lms-exams`)
      .then(response => {
        obx.lmsExams = response.data.results;

        SessionStore.finishLoading('getLMSExams');

        // Strip out HTML tags from descriptions
        for(let i = 0; i < obx.lmsExams.length; i++) {
          let description = obx.lmsExams[i].description;
          let div = document.createElement('div');
          div.innerHTML = description;
          obx.lmsExams[i].description = div.textContent || div.innerText || '';
        }
      })
      .catch(error => {
        if(failedCallback) {
          SessionStore.finishLoading('getLMSExams');
          failedCallback();
        } else {
          SessionStore.throwError(error);
        }
      })
  }),
  // Use LMS exam for new exam
  importedLmsExam: {},
  selectLMSExam: action(function(i){
    obx.importedLmsExam = obx.lmsExams[i];
  }),
  // Reset LMS exam data
  resetLMSExams: action(function(){
    obx.lmsExams = [];
    obx.importedLmsExam = {};
  }),
  sessionMeta: null,
  getSessionMeta: action(function(examSid, sessionSid, callback){
    SessionStore.startLoading('Loading…', 'getSessionMeta');
    SessionStore.modalLoaded = false;

    api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/meta`)
      .then(response => {
        obx.sessionMeta = response.data;

        if(callback) {
          callback();
        }

        SessionStore.modalLoaded = true;

        SessionStore.finishLoading('getSessionMeta');
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  /**
   * getAutomatedOptions - Gets all automated exam options
   */
  automatedOptions: [],

  getAutomatedOptions: action(function(categorySid){
    api.get(`/proctors/categories/${categorySid}/modalityOptions`)
      .then(response => {
        obx.automatedOptions = response.data.optionGroups;
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  /**
   * getModalityPresets - Gets preset configurations for exam modality settings
   */
  modalityPresets: [],

  getModalityPresets: action(function(callback){
    SessionStore.startBackgroundLoading('getModalityPresets');

    api.get(`/installs/${SessionStore.userData.installSid}/modalityPresets`)
      .then(response => {
        obx.modalityPresets = response.data.presets;

        SessionStore.finishBackgroundLoading('getModalityPresets');

        if(callback) {
          callback();
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  /**
   * getModalityPreset - Gets an individual modality preset by SID
   */
  modalityPreset: null,

  getModalityPreset: action(function(sid, callback){
    obx.modalityPresets.forEach(preset => {
      if(preset.sid === sid) {
        obx.modalityPreset = preset;
      }
    });

    if(callback) {
      callback();
    }
  }),

  /**
   * getSessionStart - Gets exam, course, session, etc. data to send to automated extension
   * @param {string} examSid
   * @param {string} sessionSid
   * @param {boolean} hybrid
   * @param {function} callback
   */
  sessionStartData: null,

  getSessionStart: action(function(examSid, sessionSid, hybrid, callback){
    let url = `/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/start`;

    if(hybrid) {
      url += '?hybrid=true';
    }

    api.get(url)
      .then(response => {
        obx.sessionStartData = response.data;

        if(!obx.sessionStartData.exam.configuration.modalityOptions) {
          obx.sessionStartData.exam.configuration.modalityOptions = obx.sessionStartData.modalityOptions;
        }

        if(callback) {
          callback(toJS(obx.sessionStartData));
        }
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
    }),

  getSessionStartOutside: action(function(examSid, sessionSid, installSid){
    let url = `/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/start`;

    return api.get(url)
      .then(response => {
        return toJS(response.data);
      })
      .catch(error => {
        SessionStore.throwError(error);
      })
  }),

  /**
     * examFlags - A "flag" is an Automated Session Annotation of severity "red".
     * Get all automated "flags" for a given exam.
     */
    examFlags: {},

    getExamFlags: action(function(examSid){
      api.get(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/annotationsByStudent?severity=red`)
        .then(response => {

          obx.examFlags = response.data;
        })
        .catch(error => {
          SessionStore.throwError(error);
        });
      }
    ),

  /**
   * Raise the whoops status annotation when the extension is not installed or is outdated
   */
  raiseAnnotation: action(function(examSid, sessionSid, annotationType){

    const body = {
      title: annotationType.title,
      severity: annotationType.severity
        || "yellow",
      type: annotationType.type
        || "manual",
      sessionTime: annotationType.sessionTime || 0,
      details: JSON.stringify(annotationType.details) || "",
      createdBy: "system",
      status: "pending review"
    }
    api.post(`/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/annotations`, body).then(response => {
      console.log(response);
    }).catch((e) => {
      console.log('raise Annotation error', e);
      console.error(e.message);
    });
  }),

    /**
     * Set the reviewed status of an automated session
     *
     * @function updateReviewStatus
     * @param {object} urlData
     * @param {object} payload
     */
    updateReviewStatus: (urlData, payload) => {
      const { examSid, sessionSid } = urlData;

      const url = `/installs/${SessionStore.userData.installSid}/exams/${examSid}/sessions/${sessionSid}/reviewStatus`;

      api.patch(url, payload)
        .catch(error => {
          SessionStore.throwError(error);
        });
    },
  getOnboardingUrl: (examSid, sessionSid, installSid) => {

    api.get(`/installs/${installSid}/exams/${examSid}/sessions/${sessionSid}/onboard`).then(response => {
      console.log(response);
      return response;
    })
      .catch((e) => {
        console.error(e);
      })

  }

});

// Initialize exam.platformVersion with the default value
obx.exam.platformVersion = obx.defaultPlatformVersion;

export default obx;



// WEBPACK FOOTER //
// ./src/app/stores/ExamStore.js